import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('user/properties')

export const FETCH_USER_PROPERTIES = makeConstant('FETCH_USER_PROPERTIES')
export const FETCH_USER_PROPERTIES_PENDING = makeConstant('FETCH_USER_PROPERTIES_PENDING')
export const FETCH_USER_PROPERTIES_CANCELLED = makeConstant('FETCH_USER_PROPERTIES_CANCELLED')
export const FETCH_USER_PROPERTIES_FAILED = makeConstant('FETCH_USER_PROPERTIES_FAILED')

export const UPDATE_USER_PROPERTIES = makeConstant('UPDATE_USER_PROPERTIES')
export const UPDATE_EXTENSION_USER_PROPERTIES = makeConstant('UPDATE_EXTENSION_USER_PROPERTIES')
export const UPDATE_CLASSIFICATIONS_NOTIFICATION_PROPERTIES = makeConstant('UPDATE_CLASSIFICATIONS_NOTIFICATION_PROPERTIES')
export const UPDATE_OUTBOUND_NOTIFICATION_PROPERTIES = makeConstant('UPDATE_OUTBOUND_NOTIFICATION_PROPERTIES')
export const UPDATE_USER_PROPERTIES_PENDING = makeConstant('UPDATE_USER_PROPERTIES_PENDING')
export const UPDATE_USER_PROPERTIES_CANCELLED = makeConstant('UPDATE_USER_PROPERTIES_CANCELLED')
export const UPDATE_USER_PROPERTIES_FAILED = makeConstant('UPDATE_USER_PROPERTIES_FAILED')

export const RECEIVE_USER_PROPERTIES = makeConstant('RECEIVE_USER_PROPERTIES')

export const FETCH_USERS_BY_PROPERTY_NAME = makeConstant('FETCH_USERS_BY_PROPERTY_NAME')
export const FETCH_USERS_BY_PROPERTY_NAME_PENDING = makeConstant('FETCH_USERS_BY_PROPERTY_NAME_PENDING')
export const FETCH_USERS_BY_PROPERTY_NAME_SUCCESS = makeConstant('FETCH_USERS_BY_PROPERTY_NAME_SUCCESS')
export const FETCH_USERS_BY_PROPERTY_NAME_FAILURE = makeConstant('FETCH_USERS_BY_PROPERTY_NAME_FAILURE')

export const USER_AT_CONVERSATION_LIMIT = makeConstant('USER_AT_CONVERSATION_LIMIT')


// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/properties/constants.js